export default "__VITE_ASSET__CHi7SeFm__"